import { Clock, MessageSquare, Paperclip, SmilePlus } from "lucide-react";

export const inputButtons = [
  {
    key: "quickMessages",
    title: "Respostas rápidas",
    Icon: MessageSquare,
  },
  {
    key: "attachments",
    title: "Anexos",
    Icon: Paperclip,
  },
  {
    key: "schedule",
    title: "Agendamentos",
    Icon: Clock,
  },
  {
    key: "emotes",
    title: "Emotes",
    Icon: SmilePlus,
  },
];
